<template>
  <div class="flex-1 flex flex-col">
    <div class="flex flex-wrap gap-2">
      <button
        class="flex items-center justify-around w-24 flex-none border-2 px-2 rounded select-none"
        :class="mode == 'FILTER' ? 'border-lagon-200 text-lagon-800' : ''"
        @click="setMode('FILTER')"
      >
        Filtrera
        <svg
          class="fill-current"
          viewBox="0 0 24 24"
          height="18"
          width="18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M9 5C8.44772 5 8 5.44772 8 6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 9.55228 5 9 5ZM6.17071 5C6.58254 3.83481 7.69378 3 9 3C10.3062 3 11.4175 3.83481 11.8293 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H11.8293C11.4175 8.16519 10.3062 9 9 9C7.69378 9 6.58254 8.16519 6.17071 7H5C4.44772 7 4 6.55228 4 6C4 5.44772 4.44772 5 5 5H6.17071ZM15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11ZM12.1707 11C12.5825 9.83481 13.6938 9 15 9C16.3062 9 17.4175 9.83481 17.8293 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H17.8293C17.4175 14.1652 16.3062 15 15 15C13.6938 15 12.5825 14.1652 12.1707 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H12.1707ZM9 17C8.44772 17 8 17.4477 8 18C8 18.5523 8.44772 19 9 19C9.55228 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17ZM6.17071 17C6.58254 15.8348 7.69378 15 9 15C10.3062 15 11.4175 15.8348 11.8293 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H11.8293C11.4175 20.1652 10.3062 21 9 21C7.69378 21 6.58254 20.1652 6.17071 19H5C4.44772 19 4 18.5523 4 18C4 17.4477 4.44772 17 5 17H6.17071Z"
          />
        </svg>
      </button>
      <div
        v-for="(filterValue, key) of filters"
        :key="key"
        class="filter-item"
        :class="[
          filterValue &&
            (mode == 'FILTER' ? 'filter-active' : 'filter-selected'),
          key == 'SELECTED' && 'hidden',
        ]"
        @click="toggleFilter(key)"
      >
        {{ filterTypes[key] }}
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-5 gap-2 mt-2">
      <div class="flex flex-col gap-2 col-span-3">
        <div class="w-24 text-center text-sm">Eller</div>
        <div class="md:flex">
          <button
            class="flex items-center justify-around w-24 flex-none border-2 px-2 rounded select-none"
            :class="mode == 'SEARCH' && 'border-lagon-200 text-lagon-800'"
            @click="setMode('SEARCH')"
          >
            <span>Sök</span>
            <svg
              class="fill-current"
              viewBox="0 0 24 24"
              height="18"
              width="18"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8487 17.3729 13.551 16.3199 14.9056L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9056 16.3199C13.551 17.3729 11.8487 18 10 18C5.58172 18 2 14.4183 2 10Z"
              />
            </svg>
          </button>
          <input
            v-model="nameFilter"
            placeholder="företag eller salong"
            class="border w-full p-1 ml-2"
            :class="mode !== 'SEARCH' && 'text-gray-600'"
            @focus="setMode('SEARCH')"
          />
        </div>
        <div class="w-24 text-center text-sm">Eller</div>
        <div class="md:flex">
          <button
            class="flex items-center justify-around  flex-none border-2 px-2 rounded select-none"
            :class="mode == 'COMPANY_IDS' && 'border-lagon-200 text-lagon-800'"
            @click="setMode('COMPANY_IDS')"
          >
            <span>Ange företags-ID:n</span>
          </button>
          <input
            :value="companyIdsSearchRaw"
            placeholder="företags-id:n"
            class="border w-full p-1 ml-2"
            :class="mode !== 'COMPANY_IDS' && 'text-gray-600'"
            @input="companyIdsForSearch = $event.target.value"
            @focus="setMode('COMPANY_IDS')"
          />
        </div>
      </div>

      <label
        v-show="isManualSelection"
        class="mt-1 block col-span-2"
        :class="mode === 'COMPANY_IDS' && 'self-end'"
      >
        <span>
          Eget filternamn
        </span>
        <input
          v-model="filterNote"
          placeholder="Skriv en kommentar"
          class="border w-full p-1"
        />
      </label>
    </div>
    <div class="flex-1 min-h-0 flex items-stretch mt-4">
      <div class="flex-1 min-h-0 overflow-auto ml-24 pl-2">
        <transition
          name="fade"
          :duration="{ enter: 100, leave: 100 }"
          mode="out-in"
        >
          <p v-if="loading">Laddar...</p>
          <p v-else-if="saloons.length == 0 && readyToSearch && !filters.ALL">
            Inga salonger hittades
          </p>
          <div v-else>
            <ul
              v-for="(company, index) of companies"
              :key="company.id + index"
              class="bg-gray-500"
            >
              <li
                v-if="isManualSelection"
                class="font-semibold flex justify-between hover:opacity-75 items-center bg-gray-300 px-2 py-1"
                @click="toggleCompanySelected(company.id)"
              >
                <span>{{ company.displayname || company.name }}</span>
                <input
                  type="checkbox"
                  class="w-4 h-4"
                  :checked="allSaloonsInCompanyAreSelected(company.id)"
                />
              </li>
              <li
                v-else
                class="font-semibold flex justify-between items-center bg-gray-300 px-2 py-1"
              >
                <span>{{ company.displayname || company.name }}</span>
              </li>
              <ul
                class="bg-gray-500 border-b border-gray-400 divide-y divide-gray-300"
              >
                <li
                  v-for="saloon of saloonsInCompany(company.id)"
                  :key="saloon.id"
                  class="flex justify-between bg-gray-200 items-center pl-6 pr-2 py-px"
                  :class="isManualSelection && 'hover:opacity-75'"
                  @click="isManualSelection && toggleSaloonSelected(saloon)"
                >
                  <span>{{ saloon.name }}</span>
                  <input
                    v-show="isManualSelection"
                    type="checkbox"
                    class="w-4 h-4"
                    :checked="selectedSaloonIds.includes(saloon.id)"
                  />
                </li>
              </ul>
            </ul>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import GET_SALOONS from '@/graphql/Saloons.gql'
import filterTypes from './filterTypes'

const filters = Object.assign(
  ...Object.keys(filterTypes).map(filter => ({ [filter]: false }))
)

export default {
  name: 'Recipients',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    saloons: {
      query: GET_SALOONS,
      update: data => data.saloons || [],
      result({ data }) {
        if (data && data.saloons.length >= 0) {
          if (this.mode == 'FILTER') {
            this.emitRecipients()
          }
          if (this.mode == 'COMPANY_IDS') {
            this.selectedSaloons = [...data.saloons]
            this.emitRecipients()
          }
        } else {
          this.saloons = []
        }
      },
      variables() {
        const activeFilters = Object.keys(this.filters).filter(
          key => !['ALL', 'SELECTED'].includes(key) && !!this.filters[key]
        )

        const filtersUsed = activeFilters.length
          ? Object.assign(...activeFilters.map(key => ({ [key]: true })))
          : undefined

        switch (this.mode) {
          case 'FILTER':
            return {
              where: {
                ...filtersUsed,
              },
            }
          case 'COMPANY_IDS':
            return {
              where: {
                companyIds: this.companyIdsForSearch,
              },
            }
          case 'SEARCH':
            return {
              where: {
                name: this.searchText,
              },
            }
        }
      },
      skip() {
        return (
          !this.readyToSearch ||
          (this.mode == 'FILTER' && this.filters.ALL) ||
          (this.mode == 'SEARCH' && this.searchText == '') ||
          (this.mode == 'COMPANY_IDS' && this.companyIdsForSearch.length == 0)
        )
      },
      loadingKey: 'loading',
    },
  },
  data() {
    return {
      filterTypes,
      filters,
      filterNote: '',
      saloons: [],
      selectedSaloons: [],
      readyToSearch: false,
      loading: 0,
      mode: 'FILTER',
      searchText: '',
      companyIdsSearchRaw: '',
    }
  },
  computed: {
    isManualSelection() {
      return this.mode == 'SEARCH' || this.mode == 'COMPANY_IDS'
    },
    companyIdsForSearch: {
      get() {
        if (!this.companyIdsSearchRaw) {
          return []
        }
        return this.companyIdsSearchRaw.split(/[\W]+/).reduce((acc, id) => {
          const trimmedId = id.replace(/[\W]+/g, '')
          if (trimmedId && trimmedId.length > 22) {
            acc.push(trimmedId)
          }
          return acc
        }, [])
      },
      set(value) {
        this.companyIdsSearchRaw = value
        if (this.companyIdsForSearch.length) {
          this.debounceSearch()
        }
      },
    },
    companies() {
      return [...new Set(this.saloons.map(s => s.company))]
    },
    selectedSaloonIds() {
      return this.selectedSaloons.map(s => s.id)
    },
    nameFilter: {
      get() {
        return this.searchText
      },
      set(value) {
        this.searchText = value

        if (value.length >= 3) {
          this.debounceSearch()
        }
      },
    },
    filtersUsed() {
      if (this.isManualSelection) {
        return ['SELECTED', this.filterNote].filter(Boolean)
      }
      return Object.keys(this.filters).filter(key => this.filters[key])
    },
  },
  methods: {
    emitRecipients() {
      const selectedSaloons = (() => {
        if (this.isManualSelection) {
          return this.selectedSaloons
        }
        return this.filters.ALL ? [] : this.saloons
      })()

      const recipients = {
        selectedSaloons,
        filtersUsed: this.filtersUsed,
      }

      this.$emit('input', recipients)
    },
    setMode(mode) {
      if (this.mode === mode) {
        return
      }
      this.mode = mode
      this.searchText = ''
      this.companyIdsSearchRaw = ''

      if (Object.values(this.filters).filter(v => !!v).length == 0) {
        this.filters.ALL = true
      }

      this.emitRecipients()
    },
    debounceSearch() {
      this.readyToSearch = false

      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
      }

      this.searchTimeout = setTimeout(() => {
        this.readyToSearch = true
      }, 500)
    },
    toggleFilter(key) {
      this.setMode('FILTER')

      if (key == 'ALL') {
        Object.keys(this.filters).map(key => (this.filters[key] = false))
      } else {
        this.filters[key] = !this.filters[key]
        this.filters.ALL = false
      }

      if (Object.values(this.filters).filter(v => !!v).length == 0) {
        this.filters.ALL = true
      }

      this.emitRecipients()
      this.debounceSearch()
    },
    toggleSaloonSelected(saloon) {
      const indexOfSelectedSaloon = this.selectedSaloons.findIndex(
        s => s.id == saloon.id
      )

      if (indexOfSelectedSaloon > -1) {
        this.selectedSaloons.splice(indexOfSelectedSaloon, 1)
      } else {
        this.selectedSaloons.push(saloon)
      }

      this.emitRecipients()
    },
    toggleCompanySelected(id) {
      if (!this.allSaloonsInCompanyAreSelected(id)) {
        this.saloonsInCompany(id)
          .filter(s => !this.selectedSaloons.includes(s))
          .forEach(s => this.toggleSaloonSelected(s))
      } else {
        this.saloonsInCompany(id).map(s => this.toggleSaloonSelected(s))
      }
    },
    saloonsInCompany(companyId) {
      return this.saloons.filter(s => s.company.id == companyId)
    },
    allSaloonsInCompanyAreSelected(companyId) {
      return this.saloonsInCompany(companyId).every(s =>
        this.selectedSaloonIds.includes(s.id)
      )
    },
  },
  watch: {
    filters: {
      handler({ ALL }) {
        if (ALL) {
          this.saloons = []
        }
      },
      deep: true,
    },
    filtersUsed() {
      this.emitRecipients()
    },
  },
}
</script>
